import React from "react";
import useWindowSize from "../hooks/useWindowSize";

const withWindowSize = WrappedComponent => props => {
  const { width } = useWindowSize();
  return <WrappedComponent {...props} width={width} />;
};

export { withWindowSize };
